export const IMPORT_MODE = {
  ADD: "add",
  ADD_OVERWRITE: "addOverwrite",
  ADD_ERASE_ALL_EXISTING: "addEraseAllExisting",
};

export const importModeLabels = () => {
  return {
    [IMPORT_MODE.ADD]: "Add",
    [IMPORT_MODE.ADD_OVERWRITE]: "Add & overwrite duplicates",
    [IMPORT_MODE.ADD_ERASE_ALL_EXISTING]: "Add & erase all existing data",
  };
};
